<mat-tab-group [(selectedIndex)]="activeTab">
  <mat-tab
    label="All ({{
      getPulsesByStatus('processed').length | appFormat : 'number'
    }})"
  >
    <div *ngIf="getPulsesByStatus('processed').length; else noProcessed">
      <div class="flex-container-1">
        <ng-container
          *ngFor="let x of getPulsesByStatus('processed'); let i = index"
        >
          <ng-container
            *ngTemplateOutlet="pulseCard; context: { $implicit: x }"
          ></ng-container>
        </ng-container>
      </div>
    </div>
    <ng-template #noProcessed>
      <div style="text-align: center; margin-top: 25px">
        {{ commonText.no_records_found }}
      </div>
    </ng-template>
  </mat-tab>

  <mat-tab
    *ngIf="showPreprocessed"
    label="Preprocessed ({{ getPulsesByStatus('preprocessed').length }})"
  >
    <div *ngIf="getPulsesByStatus('preprocessed').length; else noPreprocessed">
      <div class="flex-container-1">
        <ng-container
          *ngFor="let x of getPulsesByStatus('preprocessed'); let i = index"
        >
          <ng-container
            *ngTemplateOutlet="pulseCard; context: { $implicit: x }"
          ></ng-container>
        </ng-container>
      </div>
    </div>
    <ng-template #noPreprocessed>
      <div style="text-align: center; margin-top: 25px">
        {{ commonText.no_records_found }}
      </div>
    </ng-template>
  </mat-tab>

  <mat-tab
    label="Positive ({{ getPositivePulses().length | appFormat : 'number' }})"
  >
    <div *ngIf="getPositivePulses().length; else noPositive">
      <div class="flex-container-1">
        <ng-container *ngFor="let x of getPositivePulses(); let i = index">
          <ng-container
            *ngTemplateOutlet="pulseCard; context: { $implicit: x }"
          ></ng-container>
        </ng-container>
      </div>
    </div>
    <ng-template #noPositive>
      <div style="text-align: center; margin-top: 25px">
        {{ commonText.no_records_found }}
      </div>
    </ng-template>
  </mat-tab>

  <mat-tab
    label="Negative ({{ getNegativePulses().length | appFormat : 'number' }})"
  >
    <div *ngIf="getNegativePulses().length; else noNegative">
      <div class="flex-container-1">
        <ng-container *ngFor="let x of getNegativePulses(); let i = index">
          <ng-container
            *ngTemplateOutlet="pulseCard; context: { $implicit: x }"
          ></ng-container>
        </ng-container>
      </div>
    </div>
    <ng-template #noNegative>
      <div style="text-align: center; margin-top: 25px">
        {{ commonText.no_records_found }}
      </div>
    </ng-template>
  </mat-tab>
</mat-tab-group>

<ng-template #pulseCard let-x>
  <div class="flex-item p-1 hubble-card">
    <div
      class="trn-x"
      [ngStyle]="{ background: x.color }"
      style="height: 260px"
      (click)="showEditPulseDialog(x)"
    >
      <div [matTooltip]="x.title" class="mb-0 trn-nm w-75 text-truncate">
        {{ x.title }}
      </div>
      <div class="mb-0 mt-2 trn-ph" *ngIf="x.created_by">
        <div class="d-flex align-items-center">
          <mat-icon class="small-icon me-1">perm_identity</mat-icon>
          <span>Raised by</span>
        </div>
        <span style="display: flex; font-weight: 700">
          {{ x.created_by.first_name + " " + x.created_by.last_name }}
        </span>
      </div>
      <p class="mb-0 mt-2 trn-ph">
        Created On
        <span style="display: flex; font-weight: 700">
          {{ (x.created_on | appFormat : "date") || "-" }}
        </span>
      </p>
      <p class="mb-0 mt-2 trn-ph">
        Due By
        <span style="display: flex; font-weight: 700">
          {{ (x.end_date | appFormat : "date") || "-" }}
        </span>
      </p>
      <div class="mb-0 mt-2 trn-ph">
        <div
          *ngIf="x.is_positive"
          class="font align-items-center gap-2"
          style="display: flex; font-weight: 700"
        >
          <span class="positive-pulse"></span>
          <span>Positive</span>
        </div>
        <div
          *ngIf="!x.is_positive"
          class="font align-items-center gap-2"
          style="display: flex; font-weight: 700"
        >
          <span class="negative-pulse"></span>
          <span>Negative</span>
        </div>
      </div>
      <div class="mb-0 mt-2 trn-ph">
        <div class="d-flex align-items-center">
          <span class="font">Performance Impact</span>
        </div>
        <span class="font" style="display: flex; font-weight: 700">
          {{ x.impact }}
        </span>
      </div>
      <button
        *appHasAccess="{ roles: ['!vendor'] }"
        mat-icon-button
        class="action-vert"
        color="warn"
        (click)="deletePulse(x.id, x.name); $event.stopPropagation()"
      >
        <mat-icon style="font-size: 15px; color: red">delete</mat-icon>
      </button>
    </div>
  </div>
</ng-template>
